import { LenderName } from '@nemuru-eng/js-api-client';

import { CopyToClipboardButton } from '@/components/shared/components/CopyToClipboardButton';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';
import { LenderIcon } from '@/components/shared/components/Logo/LenderLogo/LenderIcon';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface LenderRequestIdLinkProps {
  lenderRequestId: string;
  lenderName: LenderName;
}

export const LenderRequestIdLink = ({ lenderRequestId, lenderName }: LenderRequestIdLinkProps) => {
  const { palette } = useCustomTheme();

  return (
    <FlexRow color={palette.text.secondary} gridGap={16} width={'100%'}>
      <FlexRow justifyContent="flex-start" gridGap={8} minWidth={0}>
        <LenderIcon lenderName={lenderName} size={16} />
        <Font variant="body2" color="textSecondary" className="overflow-text-ellipsis">
          <Text tId={'LENDER_REQUEST_ID_2'} />: {lenderRequestId}
        </Font>
      </FlexRow>
      <FlexRow gridGap={8}>
        <CopyToClipboardButton style={{ color: palette.text.secondary }} value={lenderRequestId.toString()} />
      </FlexRow>
    </FlexRow>
  );
};
